import {
  hasOrganizationAdminRole,
  hasProjectManagementAccess,
  IsNotMyAccount,
  IsOrganizationに所属している,
  IsProjectに所属している,
  IsSystemAdmin,
  orgScoped,
  projectScoped,
  Synth,
} from './common';

export namespace Authorization {
  export namespace Can {
    export namespace Account {
      export const AssignOrganizationRole = orgScoped(Synth.And(IsNotMyAccount, Synth.Or(hasOrganizationAdminRole, IsSystemAdmin)));
      export const AssignPermissionGroup = hasProjectManagementAccess;
      export const UnlockLoginAttemptLockoutInOrganization = orgScoped(Synth.And(IsNotMyAccount, IsSystemAdmin));
      export const UnlockLoginAttemptLockoutInProject = projectScoped(Synth.And(IsNotMyAccount, IsSystemAdmin));
      export const ListSystemAdmin = IsSystemAdmin;
      export const ListRighttouchAccounts = IsSystemAdmin;
      export const UpdateIsSystemAdmin = Synth.And(IsNotMyAccount, IsSystemAdmin);
      export const DeactivateManagedAccount = Synth.And(IsNotMyAccount, IsSystemAdmin);
      export const ReactivateManagedAccount = IsSystemAdmin;
      export const ListAccountGrants = IsSystemAdmin;
      export const GrantDurableAccountGrant = IsSystemAdmin;
      export const RevokeAccountGrant = IsSystemAdmin;
      export const ResetMfa = IsSystemAdmin;
      export const SetSamlLoginEnforced = orgScoped(Synth.Or(hasOrganizationAdminRole, IsSystemAdmin));
    }

    export namespace Organization {
      export const Create = IsSystemAdmin;
      export const Get = orgScoped(Synth.Or(IsOrganizationに所属している, IsSystemAdmin));
      export const ListAll = IsSystemAdmin;
      export const ListMembers = orgScoped(Synth.Or(hasOrganizationAdminRole, IsSystemAdmin));
      export const Update = orgScoped(Synth.Or(hasOrganizationAdminRole, IsSystemAdmin));
      export const UpdateEntitlements = IsSystemAdmin;
      export const InviteMember = orgScoped(Synth.Or(IsSystemAdmin, hasOrganizationAdminRole));
      export const RemoveMember = orgScoped(Synth.And(IsNotMyAccount, Synth.Or(hasOrganizationAdminRole, IsSystemAdmin)));
    }

    export namespace Project {
      export const Create = IsSystemAdmin;
      export const Get = Synth.Or(projectScoped(IsProjectに所属している), hasProjectManagementAccess);
      export const ListAll = IsSystemAdmin;
      // 組織配下の全プロジェクト一覧。組織管理者は所属していないプロジェクトも含め一覧できる (監査ログ export の選択肢などに使う)。
      export const ListInOrganization = orgScoped(Synth.Or(hasOrganizationAdminRole, IsSystemAdmin));
      export const ListMembers = Synth.Or(projectScoped(IsProjectに所属している), hasProjectManagementAccess);
      export const Update = hasProjectManagementAccess;
      export const UpdatePlan = IsSystemAdmin;
      export const UpdateFeatureFlags = IsSystemAdmin;
      export const InviteMember = hasProjectManagementAccess;
      export const RemoveMember = Synth.And(IsNotMyAccount, hasProjectManagementAccess);
    }

    export namespace ProjectKarteMapping {
      export const Get = IsSystemAdmin;
      export const Upsert = IsSystemAdmin;
      export const ListAll = IsSystemAdmin;
    }

    export namespace Group {
      export const Create = hasProjectManagementAccess;
      export const Update = hasProjectManagementAccess;
      export const List = hasProjectManagementAccess;
      export const Delete = hasProjectManagementAccess;
    }

    export namespace OrganizationKarteMapping {
      export const Get = IsSystemAdmin;
      export const Upsert = IsSystemAdmin;
      export const ListAll = IsSystemAdmin;
    }

    export namespace AuditLog {
      // 監査ログ export は組織管理者に開放する (システム管理者も可)。機能フラグの ON/OFF 自体は UpdateEntitlements = IsSystemAdmin 側で別途システム管理者に限定。
      // ExportProject の organizationId は対象プロジェクトの所属組織 ID を渡す。
      export const ExportOrganization = orgScoped(Synth.Or(hasOrganizationAdminRole, IsSystemAdmin));
      export const ExportProject = orgScoped(Synth.Or(hasOrganizationAdminRole, IsSystemAdmin));
    }

    export namespace Saml {
      export const GetConfig = orgScoped(Synth.Or(hasOrganizationAdminRole, IsSystemAdmin));
      export const UpsertConfig = orgScoped(Synth.Or(hasOrganizationAdminRole, IsSystemAdmin));
      export const RebuildAllEntryGateCaches = IsSystemAdmin;
    }

    export namespace VerifiedDomain {
      export const List = orgScoped(Synth.Or(hasOrganizationAdminRole, IsSystemAdmin));
      export const Create = orgScoped(Synth.Or(hasOrganizationAdminRole, IsSystemAdmin));
      export const Delete = orgScoped(Synth.Or(hasOrganizationAdminRole, IsSystemAdmin));
      export const Verify = orgScoped(Synth.Or(hasOrganizationAdminRole, IsSystemAdmin));
    }
  }
}

export * from './common';
